import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Event, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TenantLoginInfoDto } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'vf-subscription-success-modal',
  templateUrl: './subscription-success-modal.component.html'
})
export class SubscriptionSuccessModalComponent extends AppComponentBase implements OnInit {

  @ViewChild('subscriptionSuccessModal') modal: ModalDirective;
  isFromBanner = false;
  tenant: TenantLoginInfoDto = new TenantLoginInfoDto();
  url = '';
  planName = '';
  constructor(injector: Injector,
    private router: Router) {
    super(injector);
    this.router.events.subscribe((event: Event) => {
      if (this.router.url !== '') {
        this.url = this.router.url;
      }
    });
  }

  ngOnInit() {
  }

  show(data?: any): void {
    if (data) {
      if (data[0]) {
        this.planName = data[0];
      }
      if (data[1]) {
        this.isFromBanner = data[1];
      }
    }
    this.modal.show();
    setTimeout(() => {
      this.updateBodyForCenterModalShow();
    }, 600);
  }

  sendToSettings(): void {
    this.modal.hide();
    this.updateBodyForCenterModalHide();
    // need to get the session again after subscription is successful.
    location.reload();
    // if (this.isFromBanner && this.url !== '/app/settings') {
    //   this.router.navigate(['app/settings']);
    // } else if (this.url === '/app/settings') {
    //   // need to get the session again after subscription is successful.
    //   location.reload();
    // } else {
    //   // need to get the session again after subscription is successful.
    //   location.reload();
    // }
  }

}
